<template>
  <div>
    <div class="chart-toggle">
      <button @click="currentChart = 'line'">Line Chart</button>
      <button @click="currentChart = 'column'">Column Chart</button>
      <button @click="currentChart = 'area'">Area Chart</button>
    </div>

    <!-- Render selected chart -->
    <dataChart :options="chartOptions" :constructor-type="'chart'" />
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";

export default {
  name: "AnalyticsChart",
  components: {
    dataChart: Chart,
  },
  props: {
    analyticsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentChart: "line",
    };
  },
  computed: {
    chartOptions() {
      if (!this.analyticsData || this.analyticsData.length === 0) {
        return {
          title: { text: "No Data Available" },
          series: [],
        };
      }

      const categories = this.analyticsData.map((d) => d.date);
      const submissions = this.analyticsData.map((d) => d.submissions);
      const uniqueUsers = this.analyticsData.map((d) => d.uniqueUsersCount);

      return {
        chart: { type: this.currentChart },
        title: { text: "Engagement Analytics" },
        xAxis: { categories },
        yAxis: { title: { text: "Count" } },
        tooltip: { shared: true },
        plotOptions: {
          area: {
            stacking: "normal",
            marker: { enabled: false },
          },
        },
        series: [
          {
            name: "Submissions",
            data: submissions,
          },
          {
            name: "Unique Users",
            data: uniqueUsers,
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.chart-toggle {
  margin-bottom: 1rem;
}
.chart-toggle button {
  margin-right: 8px;
  padding: 6px 12px;
  background: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
}
.chart-toggle button:hover {
  background: #e0e0e0;
}
</style>
